import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { FeatherIcon } from "component/shared/feather-icon";
import { Integration } from "model/integration";

interface Props {
    open: boolean;
    onClose: () => void;
    integration: Integration;
    children: React.ReactNode;
}

export function SimpleIntegrationModal({ open, onClose, integration, children }: Props) {
    return (
        <Mui.Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <Mui.DialogTitle>
                <Mui.Box display="flex" alignItems="center" justifyContent="space-between">
                    <Mui.Box display="flex" alignItems="center" style={{ gap: 10 }}>
                        {integration.integrationType.iconUrl && (
                            <img
                                src={integration.integrationType.iconUrl}
                                alt=""
                                style={{ width: 24, height: 24, objectFit: "contain" }}
                            />
                        )}
                        <Mui.Typography variant="h6">{integration.label}</Mui.Typography>
                    </Mui.Box>
                    <Mui.IconButton size="small" onClick={onClose}>
                        <FeatherIcon>
                            <Icons.X />
                        </FeatherIcon>
                    </Mui.IconButton>
                </Mui.Box>
            </Mui.DialogTitle>
            <Mui.DialogContent dividers>
                {children}
            </Mui.DialogContent>
        </Mui.Dialog>
    );
}
